module.exports = __webpack_public_path__ + "img/live_04.17a11eb4.png";